module.exports = __webpack_public_path__ + "img/Ning_Xie@2x.7fdaf0d2.png";